
import { PropsWithChildren } from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

interface DialogTitleWithCloseProps extends PropsWithChildren {
    id: string,
    onClose: () => void
}

const DialogHeader = ({ children, onClose, ...other }: DialogTitleWithCloseProps) => {
    return (
        <Box sx={{ display: 'flex', bgcolor: 'primary.main' }}>
            <Box sx={{ flex: 1, p: 2 }}>
                <Typography variant="subtitle2" component="p" sx={{ color: 'common.white' }}>
                    {children}
                </Typography>
            </Box>
            {onClose ? (
                <Box sx={{ width: 56 }}>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'common.white'
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            ) : null}
        </Box>
    );
}

export { DialogHeader }
